export const products = [
  {
    id: "pp-textured-yarn",
    name: "PP Textured Yarn",
    category: "Yarns",
    image: "/images/products/pp-textured-yarn.jpeg",
    shortDescription: "High bulk polypropylene textured yarns for dust proofing in FIBCs",
    specs: ["130 & 260 Denier", "UV & Non-UV", "Ex-Stock Availability"],
    description: "Made from virgin polypropylene granules, our PP Textured Yarns exhibit exceptional bulk for effective dust proofing in FIBCs. Produced via POY spinning and high-speed texturizing.",
    technicalSpecs: {
      "Denier Options": "130D Single Ply (S or Z Twist), 260D x 2 Ply (130D x 2), 130D x 4 Ply",
      "For Socks": "130 Denier Single Ply, 260 Denier",
      "Core Tow": "10000-27000 Denier for inner core",
      "Package Sizes": "1.5 to 3.5 kg",
      "Bobbin Lengths": "230 mm or 290 mm",
      "UV Protection": "Available in UV & Non-UV variants",
      "Color Options": "All colors available with superior color fastness"
    },
    applications: [
      "Dust proofing in FIBC bags",
      "Sift proofing applications",
      "Inner lining for jumbo bags",
      "High-bulk filler requirements",
      "Socks manufacturing"
    ]
  },
  {
    id: "pp-filler-cord-dust-proof-cord",
    name: "PP Filler Cord / Dust Proof Cord",
    category: "Cords",
    image: "/images/products/dust-proof-cords.jpeg",
    shortDescription: "Knit braided ropes for sealing stitching holes and preventing powder leakage",
    specs: ["3.5-6 g/m GPM", "Knotless", "Custom Colors"],
    description: "Our PP Filler Cord / Dust Proof Cord are knit braided ropes made from polypropylene with low linear weight but exceptional bulk. Designed to seal stitching holes and prevent powder leakage in single or double dust proof configurations.",
    technicalSpecs: {
      "Weight/Diameter Options": "3.5-4 g/m at 8mm, 4-4.5 g/m at 10mm, 5-6 g/m at 12mm",
      "Package Type": "Knotless 7-8 kg packages",
      "Packing": "Vacuum-packed options available",
      "Identification": "Color markings available",
      "Custom Colors": "Available on request"
    },
    applications: [
      "Sealing stitching holes in FIBC",
      "Single dust proof configuration",
      "Double dust proof configuration",
      "Powder leakage prevention"
    ]
  },
  {
    id: "pp-crimp-felt",
    name: "PP Crimp Felt",
    category: "Felts",
    image: "/images/products/crimp-yarn.jpeg",
    shortDescription: "Polypropylene felts paired with textured yarns for dust proofing",
    specs: ["15mm Width", "20mm Width", "40mm Width"],
    description: "High-quality polypropylene crimp felts designed to work in conjunction with PP textured yarns for effective dust proofing in FIBC applications. Superior bulk and filtration properties.",
    technicalSpecs: {
      "Material": "100% Polypropylene",
      "Available Widths": "15 mm, 20 mm, 40 mm",
      "Bulk Density": "Optimized for dust proofing",
      "Compatibility": "Works with PP textured yarns",
      "Thickness": "Available in various gauges",
      "Roll Length": "Standard and custom lengths"
    },
    applications: [
      "FIBC dust proofing systems",
      "Combined with textured yarns",
      "Inner lining for sift-proof bags",
      "Fine powder containment"
    ]
  },
  {
    id: "braided-ropes",
    name: "Braided Ropes",
    category: "Ropes",
    image: "/images/products/braided-ropes.jpeg",
    shortDescription: "High-strength polypropylene braided ropes in various grammage and diameters",
    specs: ["8 g/m @ 6mm", "12 g/m @ 8mm", "High Tenacity"],
    description: "Premium quality braided ropes manufactured from high-tenacity polypropylene. Available in different grammage and diameter options to suit your specific FIBC requirements.",
    technicalSpecs: {
      "Material": "High-tenacity polypropylene",
      "Grammage & Diameter": "8 grams per meter @ 6 mm diameter, 12 grams per meter @ 8 mm diameter",
      "Strength": "Superior breaking strength",
      "UV Protection": "Available on request",
      "Colors": "Standard and custom colors available"
    },
    applications: [
      "FIBC lifting loops",
      "Bag closing and securing",
      "Industrial packaging",
      "Heavy-duty tie-downs"
    ]
  },
  {
    id: "b-locks",
    name: "B-Locks",
    category: "Accessories",
    image: "/images/products/b-locks.jpg",
    shortDescription: "Unique material chemistry for fail-safe FIBC closure operation",
    specs: ["Fail-Safe Design", "Superior Material", "Reliable Closure"],
    description: "Our B-Locks feature unique material chemistry engineered for fail-safe operation. Designed to provide secure and reliable closure for FIBC bags during filling and transportation.",
    technicalSpecs: {
      "Material Chemistry": "Proprietary blend for fail-safe operation",
      "Design": "Engineered for reliable closure",
      "Compatibility": "Suitable for all standard FIBC spouts",
      "Quality Testing": "100% quality checked",
      "Shelf Life": "Extended durability under normal storage"
    },
    applications: [
      "FIBC spout closure",
      "Bag sealing during filling",
      "Transportation security",
      "Discharge control"
    ]
  },
  {
    id: "pp-fdy-yarn",
    name: "PP FDY Yarn",
    category: "Yarns",
    image: "/images/products/pp-fdy-yarn.jpeg",
    shortDescription: "Premium polypropylene fully drawn yarns for industrial applications",
    specs: ["High Tenacity", "UV Protected", "Multiple Deniers"],
    description: "High-quality PP FDY (Fully Drawn Yarn) manufactured using advanced spinning technology. Designed for superior strength and durability in industrial textile applications.",
    technicalSpecs: {
      "Denier Range": "600D to 3000D",
      "Tenacity": "High strength grade",
      "UV Protection": "UV stabilized options available",
      "Colors": "White and custom colors available",
      "Package Types": "Cone winding and bobbin winding",
      "Quality Standard": "Consistent tensile strength and elongation"
    },
    applications: [
      "Industrial fabrics",
      "FIBC fabric weaving",
      "Strapping and belts",
      "Heavy-duty textile applications",
      "Bag manufacturing"
    ]
  },
  {
    id: "tyvek-sheet",
    name: "Tyvek Sheet",
    category: "Specialty Materials",
    image: "/images/products/tyvek-sheet.jpeg",
    shortDescription: "Premium DuPont Tyvek sheets for FIBC labeling and documentation",
    specs: ["Water Resistant", "Tear Proof", "Printable"],
    description: "Genuine DuPont Tyvek sheets offering exceptional durability for FIBC labels, tags, and documentation. Combines the best properties of paper, film, and fabric.",
    technicalSpecs: {
      "Material": "DuPont Tyvek",
      "Weight": "Various GSM options available",
      "Size Options": "Standard sheets and custom sizes",
      "Printability": "Compatible with thermal and digital printing",
      "Water Resistance": "Excellent water and chemical resistance",
      "Temperature Range": "-40°C to +80°C"
    },
    applications: [
      "FIBC product labels",
      "Traceability tags",
      "Shipping documentation",
      "Barcoding and QR codes",
      "Weather-resistant labeling"
    ]
  }
];

export const industries = [
  {
    id: "fibc",
    name: "FIBC Industry",
    description: "Comprehensive solutions for Flexible Intermediate Bulk Container manufacturers worldwide.",
    image: "/images/industries-warehouse.jpg",
    useCases: [
      "Dust proofing and sift proofing solutions",
      "High-quality PP textured yarns",
      "Complete accessory range (cords, ropes, locks, felts)",
      "Customized solutions for specific applications"
    ],
    recommendedProducts: ["pp-textured-yarn", "pp-filler-cord-dust-proof-cord", "braided-ropes", "b-locks", "pp-crimp-felt"]
  },
  {
    id: "socks-hosiery",
    name: "Socks & Hosiery Industry (WINFIL Brand)",
    description: "Premium textured yarns for the socks and hosiery industry under our WINFIL brand.",
    image: "/images/winfil-yarns.jpg",
    useCases: [
      "Textured yarns for sock manufacturing",
      "All colors available on request",
      "Special carton packing for easy handling",
      "Superior color fastness"
    ],
    recommendedProducts: ["pp-textured-yarn"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    company: "Premium FIBC Manufacturers",
    location: "Gujarat, India",
    testimonial: "Big Bag Essentials has been our trusted partner for over 3 years. Their dust proofing cords are superior in quality and their delivery is always on time. The team understands our requirements perfectly.",
    rating: 5
  },
  {
    id: 2,
    name: "Mohammed Farooq",
    company: "Global Packaging Solutions",
    location: "Delhi, India",
    testimonial: "The quality of PP textured yarns is exceptional. We've tested multiple suppliers, but Big Bag Essentials consistently delivers the best bulk and tenacity. Their ex-stock availability is a game-changer for our production planning.",
    rating: 5
  },
  {
    id: 3,
    name: "Anita Sharma",
    company: "Elite Hosiery Industries",
    location: "Ludhiana, India",
    testimonial: "WINFIL textured yarns have transformed our socks production. The color fastness is outstanding, and the special carton packing makes handling so much easier. Highly recommended!",
    rating: 5
  }
];

export const blogPosts = [
  {
    id: "fibc-quality-standards-2024",
    title: "Understanding FIBC Quality Standards in 2024",
    excerpt: "A comprehensive guide to the latest quality standards and certifications for Flexible Intermediate Bulk Containers in the Indian and global markets.",
    category: "Quality & Standards",
    author: "Big Bag Essentials Team",
    date: "January 15, 2024",
    readTime: "5 min read",
    image: "/images/industries-warehouse.jpg",
    content: `
      <h2>Introduction to FIBC Quality Standards</h2>
      <p>Flexible Intermediate Bulk Containers (FIBCs) play a crucial role in modern logistics and bulk material handling. Understanding the quality standards is essential for manufacturers and buyers alike.</p>
      
      <h3>Key Quality Parameters</h3>
      <ul>
        <li><strong>Fabric Quality:</strong> The base fabric should meet GSM (grams per square meter) requirements</li>
        <li><strong>Safety Factor:</strong> Minimum 5:1 or 6:1 safety factor is standard</li>
        <li><strong>UV Treatment:</strong> Essential for outdoor storage applications</li>
        <li><strong>Dust Proofing:</strong> Critical for powder and fine material containment</li>
      </ul>
      
      <h3>ISO Certifications</h3>
      <p>Big Bag Essentials maintains ISO 9001:2015 certification, ensuring consistent quality management across all products. This certification validates our commitment to:</p>
      <ul>
        <li>Quality control processes</li>
        <li>Customer satisfaction</li>
        <li>Continuous improvement</li>
        <li>Compliance with international standards</li>
      </ul>
      
      <h3>Testing Protocols</h3>
      <p>Our rigorous testing includes:</p>
      <ul>
        <li>Tensile strength testing</li>
        <li>Top lift and bottom lift tests</li>
        <li>Cyclic top lift tests</li>
        <li>UV degradation tests</li>
        <li>Dust proofing effectiveness</li>
      </ul>
      
      <p>Understanding these standards helps you make informed decisions when selecting FIBC accessories and materials.</p>
    `
  },
  {
    id: "dust-proofing-solutions-guide",
    title: "Complete Guide to Dust Proofing Solutions for FIBCs",
    excerpt: "Learn about different dust proofing techniques, materials, and best practices for preventing powder leakage in bulk container applications.",
    category: "Technical Guide",
    author: "Big Bag Essentials Team",
    date: "December 28, 2023",
    readTime: "7 min read",
    image: "/images/products/dust-proof-cords.jpeg",
    content: `
      <h2>Why Dust Proofing Matters</h2>
      <p>Dust proofing is critical in FIBC applications where fine powders or granular materials are stored and transported. Proper dust proofing prevents product loss, contamination, and environmental issues.</p>
      
      <h3>Types of Dust Proofing Solutions</h3>
      
      <h4>1. Single Dust Proof Configuration</h4>
      <p>Uses one layer of dust proof cord between fabric layers. Suitable for:</p>
      <ul>
        <li>Standard powder applications</li>
        <li>Materials with particle size > 50 microns</li>
        <li>Cost-effective solutions</li>
      </ul>
      
      <h4>2. Double Dust Proof Configuration</h4>
      <p>Features two layers of dust proof cord for maximum protection. Ideal for:</p>
      <ul>
        <li>Ultra-fine powders</li>
        <li>High-value materials</li>
        <li>Zero-tolerance leakage requirements</li>
      </ul>
      
      <h3>Material Selection</h3>
      <p>Big Bag Essentials offers PP Filler Cords in various specifications:</p>
      <ul>
        <li><strong>3.5-4 g/m at 8mm:</strong> Standard applications</li>
        <li><strong>4-4.5 g/m at 10mm:</strong> Medium duty</li>
        <li><strong>5-6 g/m at 12mm:</strong> Heavy duty applications</li>
      </ul>
      
      <h3>Installation Best Practices</h3>
      <ol>
        <li>Ensure cord is evenly distributed in stitching holes</li>
        <li>Maintain consistent tension during installation</li>
        <li>Verify cord placement at seam intersections</li>
        <li>Test samples before full production runs</li>
      </ol>
      
      <h3>Quality Assurance</h3>
      <p>Our dust proof cords come with:</p>
      <ul>
        <li>100% quality inspection</li>
        <li>Knotless packages for smooth operation</li>
        <li>Vacuum packing options</li>
        <li>Color marking for identification</li>
      </ul>
      
      <p>Contact us for customized dust proofing solutions tailored to your specific application requirements.</p>
    `
  },
  {
    id: "pp-textured-yarn-applications",
    title: "PP Textured Yarn Applications: From FIBCs to Hosiery",
    excerpt: "Discover the versatility of polypropylene textured yarns and how they're revolutionizing both FIBC manufacturing and hosiery industries.",
    category: "Product Insights",
    author: "Big Bag Essentials Team",
    date: "December 10, 2023",
    readTime: "6 min read",
    image: "/images/products/pp-textured-yarn.jpeg",
    content: `
      <h2>The Versatility of PP Textured Yarns</h2>
      <p>Polypropylene textured yarns have emerged as a game-changing material across multiple industries. At Big Bag Essentials, we've mastered the art of producing high-quality PP textured yarns that serve diverse applications.</p>
      
      <h3>FIBC Industry Applications</h3>
      
      <h4>Dust Proofing Excellence</h4>
      <p>Our PP textured yarns provide exceptional bulk for effective dust proofing in FIBCs:</p>
      <ul>
        <li><strong>130 Denier:</strong> Single ply for standard applications</li>
        <li><strong>260 Denier (130D x 2):</strong> Double ply for enhanced performance</li>
        <li><strong>Core Tow (10000-27000 Denier):</strong> For inner core requirements</li>
      </ul>
      
      <h4>Key Benefits in FIBC Manufacturing</h4>
      <ul>
        <li>High bulk effect from German technology</li>
        <li>Superior tenacity and strength</li>
        <li>Excellent dust proofing performance</li>
        <li>UV and Non-UV variants available</li>
        <li>Ex-stock availability</li>
      </ul>
      
      <h3>WINFIL: Our Hosiery Brand</h3>
      
      <h4>Revolutionizing Socks Manufacturing</h4>
      <p>WINFIL textured yarns bring innovation to the hosiery industry:</p>
      <ul>
        <li><strong>Superior Color Fastness:</strong> Maintains vibrant colors after multiple washes</li>
        <li><strong>Excellent Bulk Effect:</strong> Creates comfortable, form-fitting socks</li>
        <li><strong>All Colors Available:</strong> Custom colors on request</li>
        <li><strong>Special Carton Packing:</strong> Easy handling and transportation</li>
      </ul>
      
      <h3>Production Excellence</h3>
      
      <h4>Our Manufacturing Process</h4>
      <ol>
        <li><strong>POY Spinning:</strong> Virgin PP granules converted to Partially Oriented Yarn</li>
        <li><strong>High-Speed Texturizing:</strong> German technology for superior bulk</li>
        <li><strong>Quality Testing:</strong> Multiple checkpoints ensure consistency</li>
        <li><strong>Custom Packaging:</strong> Tailored to customer requirements</li>
      </ol>
      
      <h3>Technical Specifications</h3>
      <p>Available configurations:</p>
      <ul>
        <li>Package sizes: 1.5 to 3.5 kg</li>
        <li>Bobbin lengths: 230 mm or 290 mm</li>
        <li>Custom winding available</li>
        <li>Both S and Z twist options</li>
      </ul>
      
      <h3>Why Choose Big Bag Essentials?</h3>
      <ul>
        <li>✓ State-of-the-art German machinery</li>
        <li>✓ Consistent quality across batches</li>
        <li>✓ Technical support from experts</li>
        <li>✓ Ex-stock availability</li>
        <li>✓ Competitive pricing</li>
      </ul>
      
      <p>Whether you're in FIBC manufacturing or the hosiery industry, our PP textured yarns deliver the performance you need. Contact us today to discuss your specific requirements.</p>
    `
  },
  {
    id: "b-locks-installation-guide",
    title: "B-Locks Installation Guide: Ensuring Fail-Safe FIBC Closure",
    excerpt: "Master the art of B-Lock installation with our comprehensive guide covering material chemistry, compatibility, and best practices.",
    category: "Installation Guide",
    author: "Big Bag Essentials Team",
    date: "November 22, 2023",
    readTime: "4 min read",
    image: "/images/products/b-locks.jpg",
    content: `
      <h2>Introduction to B-Locks</h2>
      <p>B-Locks are critical components in FIBC spout closure systems, ensuring secure sealing during filling and transportation. Understanding proper installation is key to fail-safe operation.</p>
      
      <h3>Understanding B-Lock Design</h3>
      
      <h4>Material Chemistry</h4>
      <p>Our B-Locks feature proprietary blend for fail-safe operation:</p>
      <ul>
        <li>Engineered polymer composition</li>
        <li>Optimal flexibility and strength balance</li>
        <li>UV resistance for outdoor applications</li>
        <li>Temperature tolerance: -20°C to 60°C</li>
      </ul>
      
      <h4>Design Features</h4>
      <ul>
        <li><strong>Ergonomic Shape:</strong> Easy handling during installation</li>
        <li><strong>Reliable Locking Mechanism:</strong> Prevents accidental opening</li>
        <li><strong>Universal Compatibility:</strong> Fits standard FIBC spouts</li>
        <li><strong>Quality Tested:</strong> 100% inspection before dispatch</li>
      </ul>
      
      <h3>Installation Process</h3>
      
      <h4>Step 1: Preparation</h4>
      <ol>
        <li>Inspect B-Lock for any damage</li>
        <li>Ensure spout fabric is clean and dry</li>
        <li>Verify correct B-Lock size for your spout</li>
      </ol>
      
      <h4>Step 2: Initial Positioning</h4>
      <ol>
        <li>Gather spout fabric evenly</li>
        <li>Position B-Lock at the base of gathered fabric</li>
        <li>Ensure even distribution of fabric around lock</li>
      </ol>
      
      <h4>Step 3: Securing</h4>
      <ol>
        <li>Push fabric through the B-Lock opening</li>
        <li>Ensure complete engagement</li>
        <li>Verify lock is fully seated</li>
        <li>Test closure by gentle pulling</li>
      </ol>
      
      <h3>Quality Assurance Checks</h3>
      
      <h4>Visual Inspection</h4>
      <ul>
        <li>Fabric is evenly distributed</li>
        <li>No visible gaps or loose areas</li>
        <li>B-Lock is fully engaged</li>
        <li>No damage to spout fabric</li>
      </ul>
      
      <h4>Functional Testing</h4>
      <ul>
        <li>Gentle pull test to verify security</li>
        <li>Check for ease of removal when needed</li>
        <li>Ensure lock doesn't slide during handling</li>
      </ul>
      
      <h3>Common Issues and Solutions</h3>
      
      <h4>Issue: Lock Slips During Use</h4>
      <p><strong>Solution:</strong> Ensure spout fabric is completely dry and gathered evenly before installation.</p>
      
      <h4>Issue: Difficult to Install</h4>
      <p><strong>Solution:</strong> Verify you have the correct size B-Lock for your spout diameter.</p>
      
      <h4>Issue: Lock Becomes Brittle</h4>
      <p><strong>Solution:</strong> Store B-Locks in cool, dry place away from direct sunlight. Check shelf life.</p>
      
      <h3>Storage and Shelf Life</h3>
      <ul>
        <li><strong>Storage Temperature:</strong> 15-25°C</li>
        <li><strong>Humidity:</strong> < 60% RH</li>
        <li><strong>Shelf Life:</strong> Extended durability under normal storage</li>
        <li><strong>Protection:</strong> Keep away from direct sunlight and chemicals</li>
      </ul>
      
      <h3>Why Big Bag Essentials B-Locks?</h3>
      <ul>
        <li>✓ Unique material chemistry for reliability</li>
        <li>✓ 100% quality checked</li>
        <li>✓ Compatible with all standard FIBC spouts</li>
        <li>✓ Technical support available</li>
        <li>✓ Competitive pricing with no quality compromise</li>
      </ul>
      
      <p>For bulk orders or customized requirements, contact our technical team for expert guidance.</p>
    `
  }
];
